'use client'
import { ToastContainer, Slide } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

export const ToastContainerWrapper = () => {
  return (
    <ToastContainer
      toastStyle={{ fontFamily: 'inherit', borderRadius: '8px' }}
      style={{
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: 'fit-content',
        whiteSpace: 'nowrap'
      }}
      position='top-center'
      autoClose={3000}
      hideProgressBar
      closeOnClick
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme='dark'
      transition={Slide}
    />
  )
}
